import React, { useState } from "react";
import { api } from "@/api";
import { useTranslation } from "react-i18next";

// Simple public scan simulation page
const PublicScanDemo = () => {
  const [slug, setSlug] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [newsletter, setNewsletter] = useState(false);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { t } = useTranslation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setResult(null);
    try {
      // Backend erwartet Feldname 'slug'
      const r = await api.publicScan({
        slug,
        email,
        name,
        consentNewsletter: newsletter,
      });
      setResult(r);
    } catch (e) {
      setError(e.message || t('public.scan.error') || t('public.verify.error') || 'Fehler');
    } finally {
      setLoading(false);
    }

  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-4">
      <form
        onSubmit={submit}
        className="bg-background shadow rounded p-6 w-full max-w-md space-y-4"
      >
        <h1 className="text-xl font-semibold">Public Scan Demo</h1>
        <input
          placeholder="QR Slug"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          className="border px-3 py-2 rounded w-full text-sm"
          required
        />
        <input
          placeholder="E-Mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border px-3 py-2 rounded w-full text-sm"
          required
        />
        <input
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="border px-3 py-2 rounded w-full text-sm"
        />
        <label className="flex items-center gap-2 text-xs">
          <input
            type="checkbox"
            checked={newsletter}
            onChange={(e) => setNewsletter(e.target.checked)}
          />{" "}
          {t('public.scan.newsletterConsent')}
        </label>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button
          disabled={loading}
          className="w-full bg-blue-600 text-white rounded py-2 text-sm disabled:opacity-50"
        >
          {loading ? t('public.scan.button.sending') : t('public.scanDemo.submit')}
        </button>
        {result && (
          <div className="text-xs bg-muted p-3 rounded break-all">
            <strong>Antwort:</strong>
            <pre className="whitespace-pre-wrap">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}
      </form>
    </div>
  );
};

export default PublicScanDemo;
